import type { AlternativeIdentification } from '../../types/api';

interface NameSuggestionsProps {
  suggestions: AlternativeIdentification[];
  onSelect: (suggestion: AlternativeIdentification) => void;
  onAddCustom: () => void;
}

export function NameSuggestions({
  suggestions,
  onSelect,
  onAddCustom,
}: NameSuggestionsProps) {
  if (suggestions.length === 0) {
    return (
      <div className="rounded-lg border border-editorial-gold/30 bg-editorial-gold/5 p-5 text-center">
        <span
          className="material-symbols-outlined text-editorial-gold mb-3 block"
          style={{ fontSize: 32 }}
          aria-hidden="true"
        >
          search_off
        </span>
        <h3 className="font-display font-bold text-editorial-black">
          We couldn&rsquo;t find that plant
        </h3>
        <p className="mt-1 text-sm font-serif text-gray-500">
          Try a different spelling or add it as a custom plant
        </p>
        <button
          onClick={onAddCustom}
          className="btn-editorial mt-4 group"
        >
          <span>Add as Custom Plant</span>
          <span className="material-symbols-outlined group-hover:translate-x-1 transition-transform" style={{ fontSize: 20 }} aria-hidden="true">
            arrow_forward
          </span>
        </button>
      </div>
    );
  }

  return (
    <div className="space-y-2" role="listbox" aria-label="Plant name suggestions">
      <p id="suggestions-label" className="section-header">
        Did you mean one of these?
      </p>
      <div className="space-y-2" aria-labelledby="suggestions-label">
        {suggestions.map((suggestion, index) => (
          <button
            key={index}
            onClick={() => onSelect(suggestion)}
            className="flex w-full items-center gap-3 rounded-lg border border-gray-200 bg-white p-3 text-left transition-colors hover:border-gray-400"
            role="option"
            aria-label={`Select ${suggestion.commonName} (${suggestion.scientificName})`}
          >
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/10" aria-hidden="true">
              <span className="material-symbols-outlined text-primary" style={{ fontSize: 20 }}>
                eco
              </span>
            </div>
            <div className="flex-1">
              <p className="font-display font-bold text-editorial-black">{suggestion.commonName}</p>
              <p className="text-sm font-serif italic text-gray-500">{suggestion.scientificName}</p>
            </div>
            <span className="material-symbols-outlined text-gray-400" style={{ fontSize: 20 }} aria-hidden="true">
              arrow_forward
            </span>
          </button>
        ))}
      </div>
      <div className="pt-2">
        <button
          onClick={onAddCustom}
          className="w-full min-h-[44px] rounded-lg border border-gray-300 px-4 py-2 text-sm font-sans text-gray-400 transition-colors hover:border-gray-500 hover:text-editorial-black"
        >
          None of these? Add as custom plant
        </button>
      </div>
    </div>
  );
}
